import { usePx } from "./ScreenWrapper";
import QrCodeImage from "./QrCodeImage.png";

export default function BookingFooter() {
    const px = usePx()

    return (
        <div
            style={{
                position: 'absolute',
                zIndex: 10,
                bottom: px(32),
                right: px(32),
            }}
        >
            <QrCodeSection />
        </div>
    )
}

function QrCodeSection() {
    const px = usePx();

    return (
        <div style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center'
        }}>
            <div
                style={{
                    textAlign: 'center',
                    fontSize: px(24),
                }}
            >
                <div style={{ marginBottom: px(24) }}>
                    Scan to Reserve
                </div>
            </div>
            <div
                style={{
                    width: px(124),
                    aspectRatio: '1 / 1',
                    borderRadius: '10%',
                    backgroundColor: 'white',
                    overflow: 'hidden',
                }}
            >
                <img src={QrCodeImage} alt="qr code" style={{ width: '100%', height: '100%', }} />
            </div>
        </div>
    )
}